import { useCurrentBreakpoint } from "Infrastructure/Hooks/useCurrentBreakpoint";
import { Box, Stack, useTheme } from "@mui/material";

export const UserQuestView = () => {
  const theme = useTheme();
  const { customSpacing } = theme;
  const currentBreakpoint = useCurrentBreakpoint();
  const isNarrowScreen =
    currentBreakpoint === "xs" || currentBreakpoint === "sm";

  return (
    <Box sx={{ p: isNarrowScreen ? 2 : 4 }}>
      <Stack
        spacing={customSpacing["2xl"]}
        direction={isNarrowScreen ? "column" : "row"}
        alignContent="center"
        justifyContent="center"
        sx={{
          ...(isNarrowScreen && {
            alignItems: "stretch",
            width: "100%",
          }),
        }}
      >
        {/* TODO: Add Container components in a future PR */}
      </Stack>
    </Box>
  );
};
